// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__2BBP7","section":"style_section__2L6SJ","groupTitle":"style_groupTitle__22AIw"};